import Theme from '@/utils/theme'

const myTheme = new Theme({
  primary: 'bs-primary',
  secondary: 'bs-secondary',

  // $tertiary is a plain SASS variable, not a Bootstrap theme colour, so there is no
  // --bs-tertiary custom property to read: this lookup ALWAYS misses and the fallback is
  // what actually ships. It therefore has to be the real gold — the previous #FF0000 was
  // a canary that no consumer had ever hit, and the performance chart is the first one.
  tertiary: [ '#c8a05c', (value) => value || '#c8a05c' ],

  // Fourth chart colour, same literal-with-fallback shape as tertiary. Deliberately not
  // success/danger/warning: on a performance chart green and red read as gain and loss,
  // not as "this line is the S&P".
  quaternary: [ '#8e5ea2', (value) => value || '#8e5ea2' ],

  success: 'bs-success',
  danger: 'bs-danger',
  warning: 'bs-warning',
  info: 'bs-info'
})

export default myTheme

